import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from 'lodash';

import { USE_QUERY_CONSTANTS } from 'src/constants/constants';

import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { RatingResponseProps } from '../api/response';

// const response: { data: RatingResponseProps } = camelizeKeys({
//   data: {
//     data: [
//       {
//         display_name: 'Vann***',
//         user_profile: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         rate: 3.5,
//         comment:
//           'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
//         created_at: '2022-10-05',
//       },
//       {
//         display_name: 'Chac***',
//         user_profile: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         rate: 4.5,
//         comment:
//           'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
//         created_at: '2022-10-05',
//       },
//       {
//         display_name: 'Sach***',
//         user_profile: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         rate: 3.5,
//         comment:
//           'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.',
//         created_at: '2022-10-05',
//       },
//       {
//         display_name: 'Soph***',
//         user_profile: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         rate: 2.5,
//         comment: null,
//         created_at: '2022-10-05',
//       },
//     ],
//     links: {
//       first: 'https://nham24.test/api/ratings?page=1',
//       last: 'https://nham24.test/api/ratings?page=128',
//       prev: null,
//       next: 'https://nham24.test/api/ratings?page=2',
//     },
//     meta: {
//       current_page: 1,
//       from: 1,
//       last_page: 128,
//       path: 'https://nham24.test/api/ratings',
//       per_page: '1',
//       to: 1,
//       total: 128,
//     },
//     total_reviews: 128,
//     avg_rating: 4.5,
//   },
// }) as any;

export const useRatingInfiniteQuery = ({ operatorId }: { operatorId: number }) => {
  const axios = useAxios();

  // const { data, isLoading, isError, error, isFetchingNextPage, fetchNextPage, hasNextPage, refetch, isFetching } =
  return useInfiniteQuery(
    ['rating', operatorId],
    ({ pageParam = 1 }) => {
      return axios.get<RatingResponseProps>(ApiRoutes.rating.replace('{{operator_id}}', `${operatorId}`), {
        params: { page: pageParam },
      });
    },
    {
      // getNextPageParam: lastPage => {
      //   if (lastPage?.data?.meta?.to == null) {
      //     return undefined;
      //   }
      //   return lastPage.data.meta.currentPage || 0 + 1;
      // },
      getNextPageParam: lastPage => {
        if (lastPage?.data?.links?.next) {
          return get(lastPage, 'data.meta.currentPage', 0) + 1;
        }

        return undefined;
      },
      enabled: false,
      keepPreviousData: true,
      cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    },
  );

  // return {
  //   ratingData: data,
  //   ratingIsLoading: isLoading,
  //   ratingIsError: isError,
  //   ratingError: error,
  //   ratingIsFetchingNextPage: isFetchingNextPage,
  //   ratingFetchNextPage: fetchNextPage,
  //   ratingHasNextPage: hasNextPage,
  //   ratingRefetch: refetch,
  //   ratingIsFetching: isFetching,
  // };
};
